import { render } from "./Mask.vue?vue&type=template&id=7684653b&scoped=true"
import script from "./Mask.vue?vue&type=script&lang=js"
export * from "./Mask.vue?vue&type=script&lang=js"

import "./Mask.vue?vue&type=style&index=0&id=7684653b&lang=less&scoped=true"

import exportComponent from "/Users/woniu/Desktop/woniu/web-tuiguangzu/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7684653b"]])

export default __exports__